<sc-sized-container [minWidth]="560">

  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc.visit.overview.gc-case-dialog.title"></sc-dictionary-label>
  </sc-dialog-title>

  <div class="top-info">
    <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.name"
      [scope]="data.transportScope"></app-transport-info-panel>
  </div>

  <sc-content-spacer vertical double></sc-content-spacer>

  <sc-flex centered>
    <qrcode *ngIf="data.qrCodeUrl" [qrdata]="data.qrCodeUrl" [scale]="6" [errorCorrectionLevel]="'M'"></qrcode>
  </sc-flex>

  <sc-content-spacer vertical double></sc-content-spacer>

  <div [formGroup]="detailsFormGroup" *ngIf="dynamicDisplayEnabled">

    <sc-flex centered>
      <mat-checkbox name="updateDisplayAutomatically" formControlName="updateDisplayAutomatically">
        <sc-dictionary-label
          dictionaryKey="tmc.visit.overview.gc-case-dialog.update-display-automatically"></sc-dictionary-label>
      </mat-checkbox>
      <sc-content-spacer></sc-content-spacer>
      <sc-button iconClass="fa-refresh" class="activate-display-button" mat-stroked-button (click)="activateGlobalConnectDisplayAction()"
        dictionaryKey="tmc.visit.overview.gc-case-dialog.action.activate-display-now">
      </sc-button>
    </sc-flex>
  </div>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-close-button primary [mat-dialog-close]="true" cdkFocusInitial>
    </sc-close-button>
  </sc-actionbar>

</sc-sized-container>
